import { render, staticRenderFns } from "./EditCommunityNameModal.vue?vue&type=template&id=065afce4&scoped=true&"
import script from "./EditCommunityNameModal.vue?vue&type=script&lang=ts&"
export * from "./EditCommunityNameModal.vue?vue&type=script&lang=ts&"
import style0 from "./EditCommunityNameModal.vue?vue&type=style&index=0&id=065afce4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065afce4",
  null
  
)

export default component.exports